import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeft, Layers, Cpu, ExternalLink } from 'lucide-react';

export default function ArchitecturePage() {
  const [content, setContent] = useState('');
  const [summary, setSummary] = useState(null);

  useEffect(() => {
    fetch('/api/architecture/diagram')
      .then(r => r.json())
      .then(d => setContent(d.content || ''))
      .catch(() => setContent('## Architecture diagram unavailable\nCheck back later.'));
    fetch('/api/architecture/summary').then(r => r.json()).then(setSummary).catch(() => {});
  }, []);

  return (
    <div className="min-h-screen bg-[#0A0F1C] text-white">
      <header className="border-b border-[#22304A] bg-[#0D1628]">
        <div className="max-w-7xl mx-auto px-6 py-4 flex items-center justify-between">
          <Link to="/" className="flex items-center gap-2 text-sm text-[#94A3B8] hover:text-white">
            <ArrowLeft className="w-4 h-4" /> Back to Commerce Index
          </Link>
          <div className="flex items-center gap-2">
            <Layers className="w-5 h-5 text-[#3EF1C7]" />
            <span className="font-semibold">System Architecture</span>
          </div>
        </div>
      </header>

      <div className="max-w-7xl mx-auto px-6 py-12">
        <div className="mb-12">
          <h1 className="text-4xl font-bold mb-3">Commerce Index Architecture</h1>
          <p className="text-lg text-[#94A3B8] max-w-3xl">
            Every layer of the platform documented. Source-of-truth for engineers, security reviewers, and curious customers. Updated automatically as we build.
          </p>
        </div>

        {summary && (
          <div className="mb-10 grid grid-cols-2 md:grid-cols-4 gap-4">
            <div className="bg-[#0D1628] border border-[#22304A] rounded-xl p-5">
              <Cpu className="w-5 h-5 text-[#3EF1C7] mb-2" />
              <div className="text-3xl font-bold">{summary.agent_count?.total}+</div>
              <div className="text-xs text-[#64748B] mt-1">Agents at full build</div>
            </div>
            <div className="bg-[#0D1628] border border-[#22304A] rounded-xl p-5">
              <div className="text-3xl font-bold text-[#FFA500]">{summary.memory_tiers}</div>
              <div className="text-xs text-[#64748B] mt-1">Memory tiers</div>
            </div>
            <div className="bg-[#0D1628] border border-[#22304A] rounded-xl p-5">
              <div className="text-3xl font-bold text-[#9B59B6]">{summary.flows}</div>
              <div className="text-xs text-[#64748B] mt-1">Flow orchestrators</div>
            </div>
            <div className="bg-[#0D1628] border border-[#22304A] rounded-xl p-5">
              <div className="text-3xl font-bold text-[#3498DB]">{summary.playbook_scopes}</div>
              <div className="text-xs text-[#64748B] mt-1">Playbook scopes</div>
            </div>
          </div>
        )}

        <div className="bg-[#0D1628] border border-[#22304A] rounded-xl p-8">
          <pre className="whitespace-pre-wrap text-sm text-[#94A3B8] font-mono overflow-x-auto">{content}</pre>
        </div>

        <div className="mt-8 flex gap-3">
          <Link to="/playbooks" className="inline-flex items-center gap-2 px-4 py-2 bg-[#3EF1C7] text-[#0B1120] rounded-lg font-semibold">
            Read playbooks
          </Link>
          <a href="https://commerceindex.ai/agents" target="_blank" rel="noopener noreferrer"
             className="inline-flex items-center gap-2 px-4 py-2 border border-[#22304A] rounded-lg hover:bg-[#11192A]">
            Agent reputation <ExternalLink className="w-4 h-4" />
          </a>
        </div>
      </div>
    </div>
  );
}
